// extracted by mini-css-extract-plugin
export var actions = "_fd-g";
export var benefitCard = "_fd-b";
export var benefitIcon = "_fd-d";
export var benefitLabel = "_fd-f";
export var benefits = "_fd-a";
export var benefitsSection = "_fd-8";
export var bodyText = "_fd-7";
export var closeButton = "_fd-2";
export var content = "_fd-3";
export var eyebrow = "_fd-4";
export var heading = "_fd-5";
export var image = "_fd-i";
export var imagePanel = "_fd-h";
export var modal = "_fd-0";
export var offerCard = "_fd-c";
export var offerIcon = "_fd-e";
export var sectionLabel = "_fd-9";
export var shell = "_fd-1";
export var title = "_fd-6";